import { Box } from "@chakra-ui/layout";
import useGruposDesconto from "core/features/grupo-desconto/hooks/useGruposDesconto";
import { GrupoDescontoListResponse } from "core/features/grupo-desconto/typings";
import { useEffect, useState } from "react";
import NewTable from "ui/components/NewTable";
import HeaderTable from "ui/components/Page/HeaderTable";
import EditGrupoDesconto from "components/Features/GrupoDesconto/EditGrupoDesconto";
import useGrupoDescontoColumns from "./hooks/useGrupoDescontoColumns";
import useFiltro from "infra/helpers/useFiltro";
import useDeleteGrupoDesconto from "core/features/grupo-desconto/hooks/useDeleteGrupoDesconto";
import { showSuccess } from "infra/helpers/alerta";
import PageHeader from "ui/components/Page/PageHeader/index";

function GruposDeDesconto({ tenantId }: { tenantId: string }) {
  const { filtro, onChangeFiltro } = useFiltro();

  const {
    data: gruposDesconto,
    isLoading,
    isFetching,
    refetch,
  } = useGruposDesconto(filtro, tenantId);

  const { mutate: deletarGrupoDesconto, isLoading: isLoadingDeletar } =
    useDeleteGrupoDesconto();

  const [isOpenModal, setIsOpenModal] = useState(false);
  const [editGrupoDescontoId, setEditGrupoDescontoId] = useState<
    string | undefined
  >();
  const columns = useGrupoDescontoColumns();

  useEffect(() => {
    if (!isOpenModal) {
      setEditGrupoDescontoId(undefined);
    }
  }, [isOpenModal]);

  useEffect(() => {
    if (editGrupoDescontoId) {
      setIsOpenModal(true);
    }
  }, [editGrupoDescontoId]);

  const _isLoading = isLoading || isFetching || isLoadingDeletar;
  return (
    <>
      <PageHeader
        title="Grupos de desconto"
        titleButton="Cadastrar novo grupo"
        onClick={() => setIsOpenModal(true)}
      />

      <Box>
        <NewTable
          title={() => (
            <HeaderTable
              value={filtro.search || ""}
              onSearch={(v) => onChangeFiltro("search", v)}
            />
          )}
          loading={_isLoading}
          columns={columns}
          dataSource={gruposDesconto?.items ?? []}
          actions={[
            {
              title: "Editar",
              onClick: (v: GrupoDescontoListResponse) => {
                setEditGrupoDescontoId(v.id);
              },
            },
            {
              title: "Excluir",
              onClick: (v: GrupoDescontoListResponse) => {
                deletarGrupoDesconto(v.id, {
                  onSuccess: () => {
                    showSuccess().then(() => refetch());
                  },
                });
              },
            },
          ]}
          customPagination={{
            onChangePage: (page) => onChangeFiltro("page", page),
            currentPage: gruposDesconto?.meta?.currentPage ?? 0,
            itemsPerPage: gruposDesconto?.meta?.itemsPerPage ?? 0,
            totalItems: gruposDesconto?.meta?.totalItems ?? 0,
          }}
        />
      </Box>

      <EditGrupoDesconto
        grupoDescontoEditId={editGrupoDescontoId}
        isOpenModal={isOpenModal}
        onClose={() => setIsOpenModal(false)}
        onSuccess={refetch}
      />
    </>
  );
}

export default GruposDeDesconto;
